import React, { useMemo } from "react";
import { RenderFields } from "./RenderFields";

const useFields = ({ showAmount = false, showPaymentChannel = false, showUser = false }) => {
  const [applicatedFields, setApplicatedFields] = React.useState({});

  // Estabilizar la referencia de fields basándose en el contenido
  /* eslint-disable react-hooks/exhaustive-deps */
  const fields = useMemo(() => {
    return Object.keys(applicatedFields).length > 0 ? applicatedFields : null;
  }, [JSON.stringify(applicatedFields)]);
  /* eslint-enable react-hooks/exhaustive-deps */

  const renderFields = () => (
    <RenderFields 
      showAmount={showAmount}
      showPaymentChannel={showPaymentChannel}
      showUser={showUser}
      applicatedFields={applicatedFields}
      setApplicatedFields={setApplicatedFields}
    />
  )

  return {
    fields,
    renderFields,
  };
};

export default useFields;
